import { ifNotAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/registration/activate/:token",
    name: "Activation",
    meta: { title: "Aktiviranje" },
    component: () => import(/* webpackChunkName: "Activation" */ "@/Modules/Auth/Registration/Views/Activation.vue"),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/registration/activation-success",
    name: "Activation Success",
    meta: { title: "Aktivacija uspešna" },
    component: () => import(/* webpackChunkName: "ActivationSucces" */ "@/Modules/Auth/Registration/Views/ActivationSuccess.vue"),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/registration/activation-error",
    name: "Activation Error",
    meta: { title: "Aktivacija neuspešna" },
    component: () => import(/* webpackChunkName: "ActivationError" */ "@/Modules/Auth/Registration/Views/ActivationError.vue"),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/registration/registration-success",
    name: "Registration Success",
    meta: { title: "Registracija uspešna" },
    component: () => import(/* webpackChunkName: "ActivationSucces" */ "@/Modules/Auth/Registration/Views/RegistrationSuccess.vue"),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/registration/form",
    name: "Registration",
    meta: { title: "Registracija" },
    component: () => import(/* webpackChunkName: "Registration" */ "@/Modules/Auth/Registration/Views/Registration.vue"),
    beforeEnter: ifNotAuthenticated
  },
  // The invitation that explains Competo Executive. Everything pointing at
  // /registration - the login screen included - lands here first, and the
  // "Začnite prijavo" button hands over to the form above.
  {
    path: "/registration",
    name: "Registration Intro",
    meta: { title: "Postanite Fractional Executive" },
    component: () => import(/* webpackChunkName: "RegistrationIntro" */ "@/Modules/Auth/Registration/Views/RegistrationIntro.vue"),
    beforeEnter: ifNotAuthenticated
  }
]
